module.exports = __webpack_public_path__ + "images/ABS.d9cd8d8553abf168e85cf8fb1e66e8a6.png";